import { GitBranch } from 'lucide-react'
import { useEffect, useRef, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { exchangeGithubOAuth } from '../api.js'
import { useAuth } from '../auth-context.js'
import { readGithubOAuthCallback } from '../github-oauth.js'
import { NOINDEX_ROBOTS, setPageMetadata } from '../page-metadata.js'

function GithubOAuthCallbackPage() {
  const { completeLogin } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()
  const started = useRef(false)
  const [error, setError] = useState('')

  useEffect(() => setPageMetadata({
    title: 'GitHub 登录回调 - 青途 AI',
    description: 'GitHub 登录回调页面。',
    robots: NOINDEX_ROBOTS,
  }), [])

  useEffect(() => {
    if (started.current) return
    started.current = true

    let callback
    try {
      callback = readGithubOAuthCallback(location.search)
    } catch (callbackError) {
      setError(callbackError.message)
      return
    }

    exchangeGithubOAuth(callback.code, callback.state)
      .then((data) => {
        completeLogin(data)
        navigate('/', { replace: true })
      })
      .catch((requestError) => {
        setError(requestError.message || 'GitHub 登录失败')
      })
  }, [completeLogin, location.search, navigate])

  return (
    <main className="oauth-callback-screen">
      <section className="oauth-callback-panel">
        <span className="brand-icon"><GitBranch size={24} /></span>
        {error ? (
          <>
            <h1>GitHub 登录失败</h1>
            <p role="alert">{error}</p>
            <Link className="secondary-button" to="/login">返回登录页</Link>
          </>
        ) : (
          <>
            <h1>正在完成 GitHub 登录</h1>
            <p>正在验证登录信息，请稍候。</p>
            <span className="oauth-loading" aria-hidden="true" />
          </>
        )}
      </section>
    </main>
  )
}

export default GithubOAuthCallbackPage
